module.exports = require('./helpers/bundle-url').getBundleURL('bv1uK') + require('./helpers/bundle-manifest').resolve("dBWzt");